class MapboxExpressions {
	static match(input, body, fallback) {
		return ['match', input].concat(body).concat(fallback);
	}
}

export default MapboxExpressions;
